__turbopack_context__.v({
  "button": "info-teaser-module__LmMEBq__button",
  "container": "info-teaser-module__LmMEBq__container",
  "content": "info-teaser-module__LmMEBq__content",
  "headline": "info-teaser-module__LmMEBq__headline",
  "icon": "info-teaser-module__LmMEBq__icon",
  "section": "info-teaser-module__LmMEBq__section",
});
